import { getOrderPathByStatus } from '@app/logic/Orders';
import { Order } from '@typings';
import { Link } from 'react-router-dom';

interface Props {
  order: Order.Essentials;
}

export const OrderNumberColumn = ({ order }: Props) => {
  const { order: orderId, status, orderNumber } = order;
  const path = getOrderPathByStatus(orderId, status);

  return (
    <Link to={path} className="table-row-interaction body-1">
      {orderNumber}
    </Link>
  );
};
